import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import "../../css/visitestyles.css";

import producto from "../../images/producto_blanco.png";
import montania_blanca from "../../images/montania_blanca.png";
import comunicacion_blanca from "../../images/comunicacion_blanco.png";

import { Montania } from "./home_menu/montania";
import { ProductosVisitas } from "./ProductosVisitas";
import { Ubicacion_visitas } from "../Ubicacion_visitas";
import { Company_profile } from "../../pages/company_profile";
import { ModalLogin } from "../global/ModalLogin";
import Gradient1 from '../../svg/Gradient1';

import { NavLink } from 'react-router-dom';

import { IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

import { useProveedorVisita, UserDropdown, GlobalSearch, short_logo_hosming, returnFullURL, useProovedorData } from "../../components";
import { GlobalPublications } from "../../pages/GlobalPublications";

const token = localStorage.getItem("token");

export const Navbar_visitas_empresa_uno = () => {
	const { view } = useParams();

	const { data_user, returnCurrency } = useProovedorData() || [];
	const { nit, logoCompany } = useProveedorVisita() || {};
	const [stateLogin, setStateLogin] = useState(false);
	const logoEmpresa = returnFullURL(logoCompany ?? null, "picture");

	const renderContent = () => {
		const selected = view ?? "main";

		switch (selected) {
			case "main":
				return (
					<div>
						<Montania convertPrice={returnCurrency} />
					</div>
				);
			case "products":
				return (
					<div>
						<ProductosVisitas convertPrice={returnCurrency} />
					</div>
				);
			case "us":
				return (
					<div>
						<Ubicacion_visitas />
					</div>
				);
			case "publications":
				return (
					<div className='central-main-content' style={{ margin: 'auto' }}>
						<GlobalPublications where={'company'} />
					</div>
				);
			default:
				return <div>Selecciona una opción</div>;
		}
	};

	function handleLogin() {
		if (token) setStateLogin(false);

		setStateLogin((current_val) => !current_val);
	}

	useEffect(() => {
		if (stateLogin == true) setStateLogin(false);
	}, [data_user]);

	return (
		<div>
			{/* NAVBAR */}
			<nav className='nav-company' style={{ backgroundColor: 'var(--theme-visit)' }}>
				<div className='nav-d1' style={{ backgroundColor: 'var(--theme-main)' }}>
					<NavLink
						to={'/'}
					>
						<button className="hosming-short">
							<img src={short_logo_hosming} />
						</button>
					</NavLink>

					<NavLink
						to={"/company/main?search=" + nit}
						className='nav-logo'
					>
						<img src={logoEmpresa} alt={"logo " + nit} />
					</NavLink>
				</div>

				<div className='nav-d2'>
					<ul>
						<li>
							<NavLink to={"/company/main?search=" + nit} className={({ isActive }) => isActive ? 'optionv-active' : ''}>
								<IconButton>
									<HomeIcon className='li-icon' sx={{ color: 'var(--color-icons-visit)' }} />
								</IconButton>
							</NavLink>
						</li>

						<li>
							<NavLink to={"/company/products?search=" + nit} className={({ isActive }) => isActive ? 'optionv-active' : ''}>
								<IconButton>
									{/* //FALTA COLORCARLE SU COLOR AQUI */}
									<img src={producto} className='li-icon' />
								</IconButton>
							</NavLink>
						</li>

						<li>
							<NavLink to={"/company/us?search=" + nit} className={({ isActive }) => isActive ? 'optionv-active' : ''}>
								<IconButton>
									{/* //FALTA COLORCARLE SU COLOR AQUI */}
									<img src={comunicacion_blanca} className='li-icon' />
								</IconButton>
							</NavLink>
						</li>

						<li>
							<NavLink to={"/company/publications?search=" + nit} className={({ isActive }) => isActive ? 'optionv-active' : ''}>
								<IconButton>
									{/* //FALTA COLORCARLE SU COLOR AQUI */}
									<img src={montania_blanca} className='li-icon' />
								</IconButton>
							</NavLink>
						</li>
					</ul>

					<GlobalSearch colorIcons={"visit"} handleModal={handleLogin} />

					<UserDropdown handleModal={handleLogin} />
				</div>
			</nav>

			{/* AQUÍ ABAJO RENDERIZAS EL CONTENIDO SEGÚN LA SECCIÓN SELECCIONADA */}
			<div style={{ flex: 1 }}>{renderContent()}</div>

			<ModalLogin stateModal={!token && stateLogin ? true : false} handleModal={handleLogin} />
		</div>
	);
};
